// Semplicemente elimina dall'order i product nei combo e calcola i subtotali
const resumeForPdf = (order) => {
  const res = [];
  order.forEach((item) => {
    // non fare niente con gli item dei combo di prezzo 0
    if (item.menuTitle && !item.menuPrice) return;

    if (item.menuTitle && item.menuPrice) {
      res.push({
        title: item.menuTitle,
        totalPrice: item.menuPrice * item.quantity,
        quantity: item.quantity,
        free: 0, // TODO discount per combo
      });
      return;
    }

    res.push({
      title: item.productTitle,
      totalPrice: item.productPrice * item.quantity,
      quantity: item.quantity,
      free: item.free,
    });
  });
  return res;
};
export default resumeForPdf;
